export default __webpack_public_path__ + "static/media/placeholder_portfolio02-en-mobile.7c7bc95e.png";